import { LanguageSelectorModel } from './model/language-selector.model';

export const LANGUAGES: LanguageSelectorModel[] = [
  {
    code: 'en',
    name: 'English',
    flag: 'https://flagcdn.com/w20/us.png'
  },
  {
    code: 'es',
    name: 'Español',
    flag: 'https://flagcdn.com/w20/es.png'
  },
  {
    code: 'it',
    name: 'Italiano',
    flag: 'https://flagcdn.com/w20/it.png'
  }
];
